import React from 'react';

// Static data mapping directly from the provided glossary images
const glossaryData = [
  {
    section: "Report name",
    term: "-",
    description: ["Consumer CIR"]
  },
  {
    section: "Consumer Details",
    term: "e",
    description: ["Enriched through Enquiry"]
  },
  {
    section: "Identification(s)",
    term: "ID Types",
    description: [
      "Income Tax ID Number (PAN)",
      "Passport Number",
      "Voter ID",
      "Driver's License Number",
      "Ration Card Number",
      "Universal ID Number (UID)"
    ]
  },
  {
    section: "Telephone(s) :",
    term: "Telephone Types",
    description: [
      "Latest 4 Telephone details reported.",
      "Mobile phone",
      "Home Phone",
      "Office phone",
      "Not Classified"
    ]
  },
  {
    section: "Email Contact(s) :",
    term: "-",
    description: ["Latest 4 emails reported."]
  },
  {
    section: "Employment Information(s) :",
    term: "Occupation Codes",
    description: [
      "Latest Employment detail reported.",
      "Salaried",
      "Self Employed Professionals",
      "Self Employed",
      "Others"
    ]
  },
  {
    section: "Address(es) :",
    term: "Address Category",
    description: [
      "Latest 4 address reported.",
      "Permanent Address",
      "Residence Address",
      "Office Address",
      "Not categorized"
    ]
  },
  {
    section: "Consumer Account Details:",
    term: "Account Information",
    description: [
      "Active: Account not closed",
      "Inactive: Closed account",
      "Date Opened: Date of first disbursement",
      "Date Closed: Date of account closure",
      "Date reported & Certified: Most recent date reported by reporting member",
      "Last Payment Date: Most recent date a payment was made on the account."
    ]
  },
  {
    section: "Consumer Account Details:",
    term: "Day Past Due/Asset Classification",
    description: [
      "Start date: Beginning of the payment history",
      "End Date: End of the payment history",
      "000: Payment is made on the due date",
      "001-900: Payment is missed by number of days from the due date",
      "STD: Payments being made within 90 days",
      "SMA: Special account created for reporting Standard Accounts moving toward Sub-Standard",
      "SUB: Payments being made after 90 days",
      "DBT : The account has remained Sub-Standard for 12 months",
      "LSS : The account where loss has been identified and remains uncollectable",
      "XXX : Data not reported by Institution"
    ]
  },
  {
    section: "Consumer Account Details:",
    term: "Information under dispute",
    description: [
      "Consumer has raised grievance request regarding issue in correctness of the data reported by Financial Institution"
    ]
  },
  {
    section: "Enquiry Details :",
    term: "Not Disclosed",
    description: ["Enquiry made with other Members"]
  }
];

export default function GlossarySection({ consumerName = "N/A" }) {
  return (
    <div className="w-full max-w-5xl mx-auto p-4 bg-white custom-font text-gray-900 print:p-0">
      
      {/* SECTION HEADER */}
      <h2 className="text-xl font-bold text-gray-800 mb-4 uppercase tracking-wide">
        GLOSSARY
      </h2>

      {/* TABLE CONTAINER */}
      <div className="border border-gray-400 rounded-[2px] overflow-hidden mb-12">
        
        {/* TABLE TITLE BAR */}
        <div className="px-4 py-3 bg-white border-b border-gray-400">
          <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wide">
            CIR DATA GLOSSARY
          </h3>
        </div>

        {/* GLOSSARY TABLE */}
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-white border-b border-gray-400">
              <th className="py-3 px-4 text-[11px] font-bold text-[#008c95] uppercase w-[25%] align-top">
                REPORT SECTION
              </th>
              <th className="py-3 px-4 text-[11px] font-bold text-[#008c95] uppercase w-[30%] align-top">
                KEY TERM / CODE
              </th>
              <th className="py-3 px-4 text-[11px] font-bold text-[#008c95] uppercase w-[45%] align-top">
                DESCRIPTION
              </th>
            </tr>
          </thead>
          <tbody>
            {glossaryData.map((row, index) => (
              <tr 
                key={index} 
                className="odd:bg-white even:bg-[#f7f8fa] border-b border-gray-100 last:border-0"
              >
                <td className="py-3.5 px-4 text-[11px] font-bold text-gray-900 align-top">
                  {row.section}
                </td>
                <td className="py-3.5 px-4 text-[11px] font-bold text-gray-900 align-top">
                  {row.term}
                </td>
                <td className="py-3.5 px-4 text-[11px] font-bold text-gray-900 align-top">
                  <div className="flex flex-col gap-1.5">
                    {row.description.map((line, lineIndex) => (
                      <span key={lineIndex} className="block leading-snug">
                        {line}
                      </span>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* END OF REPORT DIVIDER */}
      <div className="flex items-center justify-center my-10">
        <div className="flex-grow border-t-2 border-gray-300"></div>
        <span className="px-4 text-[11px] font-bold text-[#008c95] uppercase tracking-wide">
          END OF REPORT ON {consumerName}
        </span>
        <div className="flex-grow border-t-2 border-gray-300"></div>
      </div>

      {/* DISCLAIMER BOX */}
      <div className="border border-gray-400 rounded-[2px] p-4 mb-6">
        <h4 className="text-[11px] font-bold text-[#008c95] uppercase mb-3">
          DISCLAIMER
        </h4>
        <p className="text-[10px] text-gray-700 leading-relaxed text-justify font-bold">
          All information contained in this credit report has been collated by TransUnion CIBIL Limited (TU CIBIL) based on information provided/ submitted by its various members (“Members”), as part of periodic data submission and Members are required to ensure accuracy, completeness and veracity of the information submitted. The credit report is generated using the proprietary search and match logic of TU CIBIL. TU CIBIL uses its best efforts to ensure accuracy, completeness and veracity of the information contained in the Report, and shall only be liable and / or responsible if any discrepancies are directly attributable to TU CIBIL. The use of this report is governed by the terms and conditions of the Operating Rules for TU CIBIL and its Members.
        </p>
      </div>

      {/* FOOTER */}
      <div className="text-[9px] text-gray-600 font-bold space-y-1">
        <p>© 2023 TransUnion CIBIL Limited. (Formerly: Credit Information Bureau (India) Limited). All rights reserved.</p>
        <p className="text-gray-900 text-[10px]">TransUnion CIBIL CIN : U72300MH2000PLC128359</p>
      </div>

    </div>
  );
}